<div class="flex row root align-space-between justify-center">
    <div class="flex column align-center justify-center flex-60">
        @if (vm$ | async) {
            <!-- Placeholder for observable -->
            @if (error) {
                <mat-card appearance="outlined">
                    {{ error }}
                </mat-card>
            }
        }
        @else {
            <div class="flex column justify-center spinner">
                <mat-spinner [diameter]="40"></mat-spinner>
                <h1>Logging in...</h1>
            </div>
        }
    </div>
</div>
